__turbopack_context__.v({
  "body": "styles-module__QGaGkq__body",
  "card": "styles-module__QGaGkq__card",
  "cardTitle": "styles-module__QGaGkq__cardTitle",
  "grid": "styles-module__QGaGkq__grid",
  "head": "styles-module__QGaGkq__head",
  "heading": "styles-module__QGaGkq__heading",
  "icon": "styles-module__QGaGkq__icon",
  "root": "styles-module__QGaGkq__root",
  "sub": "styles-module__QGaGkq__sub",
});
